import React, { useState } from 'react'
import Image from 'next/image'


import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

export const analytics = AnalyticsBrowser.load(
  //@ts-ignore
  { writeKey: process.env.KA_CIO_API_KEY }
);


export default function SignUp({ firmData }) {
  const [showForm, setShowForm] = useState(true)
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    firmName: firmData?.firm_name || '',
    email: ''
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }


  const handleSignUpSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      // Submit to Customer.io using SDK
      analytics?.identify(formData.email, {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        firm_name: formData.firmName,
        initial_campaign: 'cka-sept-2025'
      })

      setShowForm(false)
    } catch (error) {
      console.error('Error submitting signup:', error)
    } finally {
      setIsSubmitting(false)
    }
  }




  return (
    <div id="signup" className="w-full px-4 py-16 md:px-16 md:py-32 relative overflow-hidden bg-[#d4e4ea]">
      {/* Background Pattern */}
      <div className="hidden md:block absolute bottom-0 right-0 w-1/2 h-full opacity-10 b">
        <Image
          src="/static/images/cka_landing/Pattern.png"
          alt="Background pattern"
          fill
          className="object-cover"
          style={{ transform: 'rotate(180deg)', filter: "brightness(50%)", }}
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8 lg:gap-16">
          {/* Left Content */}
          <div className="w-full lg:w-[570px] flex flex-col gap-8 lg:gap-12">
            <div className="flex flex-col ">

              <h2 className="text-center text-3xl md:text-4xl font-medium font-['Lora'] text-[#192f5c] p-0 m-0 mb-4 leading-tight md:leading-tight">
              Get the 2026 Pinkston research project exploring the impact of the CKA<sup style={{fontSize: '0.5em', verticalAlign: 'super'}}>®</sup> designation on advisors and their clients. 
              </h2>

              <div className="flex justify-center w-full mb-4">
                <div style ={{maxWidth:'464px'}}className="text-center text-lg font-normal font-['Instrument-Sans']  text-[#192f5c]">
                It’s scheduled for release later this year, as featured at the Redeeming Money 2026 conference.
                </div>
              </div>
          

              {/* <div className="flex flex-col md:flex-row gap-4 items-center justify-center mb-40 md:mb-0">
                <div className="w-full h-auto shadow-lg " style={{ maxWidth: '300px', maxHeight: '400px' }}>
                  <img src="/static/images/cf-report-20252.png" alt="Report" className="w-full h-auto" />
                </div>
              </div> */}
            </div>
          </div>

          {/* Right Form */}
          {
            showForm === true ?
              <>
                <div className="w-full lg:w-[660px] px-6 py-8 md:px-12 md:py-14 bg-white rounded-3xl shadow-lg">
                  <form onSubmit={handleSignUpSubmit} className="flex flex-col gap-4 md:gap-6">
                    <div className="flex flex-col sm:flex-row gap-4 ">
                      <div className="flex-1 flex flex-col gap-2">
                        <label className="text-[#192f5c] text-base  font-semibold font-['Instrument-Sans']">
                          First Name
                        </label>
                        <input
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          placeholder="First name"
                          required
                          style={{ border: '1px solid #192f5c' }}
                          className="h-14 px-3 py-2 rounded border  text-base font-normal font-['Instrument-Sans'] placeholder-[#192f5c] focus:outline-none focus:ring-1 focus:ring-[#192f5c] focus:border-transparent focus:rounded"
                        />
                      </div>
                      <div className="flex-1 flex flex-col gap-2">
                        <label className="text-[#192f5c] text-base font-semibold font-['Instrument-Sans']">
                          Last Name
                        </label>
                        <input
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          placeholder="Last name"
                          required
                          style={{ border: '1px solid #192f5c' }}
                          className="h-14 px-3 py-2 rounded border  text-base font-normal font-['Instrument-Sans'] placeholder-[#192f5c] focus:outline-none focus:ring-1 focus:ring-[#192f5c] focus:border-transparent focus:rounded"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-4">
                      {!firmData?.firm_name && (
                      <div className="flex flex-col gap-2">
                        <label className="text-[#192f5c] text-base font-semibold font-['Instrument-Sans']">
                          Firm name
                        </label>
                        <input
                          type="text"
                          name="firmName"
                          value={formData.firmName}
                          onChange={handleInputChange}
                          placeholder="Firm name"
                          required
                          style={{ border: '1px solid #192f5c' }}
                          className="h-14 px-3 py-2 rounded border  text-base font-normal font-['Instrument-Sans'] placeholder-[#192f5c] focus:outline-none focus:ring-1 focus:ring-[#192f5c] focus:border-transparent focus:rounded"
                        />  
                      </div>
                      )}
                      <div className="flex flex-col gap-2">
                        <label className="text-[#192f5c] text-base font-semibold font-['Instrument-Sans']">
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder="Email"
                          required
                          style={{ border: '1px solid #192f5c' }}
                          className="h-14 px-3 py-2 rounded border  text-base font-normal font-['Instrument-Sans'] placeholder-[#192f5c] focus:outline-none focus:ring-1 focus:ring-[#192f5c] focus:border-transparent focus:rounded"
                        />
                      </div>
                    </div>

                    <div className="flex justify-center md:justify-end">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full  px-8 py-4 bg-[#192f5c] rounded text-white text-base font-medium font-['Instrument-Sans']  transition-colors disabled:opacity-50 disabled:cursor-not-allowed border-none"
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                      </button>
                    </div>
                  </form>
                </div>
              </>
              :
              <>
                <div className="w-full lg:w-[660px] px-6 py-8 md:px-12 md:py-14 bg-white rounded-3xl shadow-lg">
                  <div className="text-left">
                    <h2 className="text-2xl md:text-4xl font-medium font-['Lora'] text-[#192f5c] mb-6">
                      Thank You!
                    </h2>
                    <p className="text-lg md:text-2xl font-normal font-['Instrument-Sans'] text-[#192f5c] mb-8">
                    Thank you for your interest in the CKA® training. We’ve received your information and will be in touch about the impact of a CKA® research report.
                    </p>
                    {/* <p className="text-base md:text-base font-light font-['Instrument-Sans'] text-[#192f5c]">
                      You should receive a confirmation email shortly. If you have any questions, please don&apos;t hesitate to contact us.
                    </p> */}
                  </div>
                </div>
              </>
          }

        </div>
      </div>
    </div>
  )






}
